import Tippy from '@tippyjs/react';
import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import CheckMarkIcon from './checkmark-icon.svg';
import ExclamationMarkIcon from './exclamation-mark-icon.svg';

type Props = {
  isWinning: boolean;
  size?: number;
};

const AuctionStatusIcon: VFC<Props> = ({ isWinning, size = 20 }: Props) => {
  const { t } = useTranslation();

  if (isWinning) {
    return (
      <Tippy content={t('auctionActivity.status.winning')} hideOnClick={false}>
        <span>
          <CheckMarkIcon style={{ width: size, height: size }} />
        </span>
      </Tippy>
    );
  }

  return (
    <Tippy content={t('auctionActivity.status.losing')} hideOnClick={false}>
      <span>
        <ExclamationMarkIcon style={{ width: size, height: size }} />
      </span>
    </Tippy>
  );
};

export default AuctionStatusIcon;
